module.exports = __webpack_public_path__ + "c7712c15a20134df4d33e5d4760525d9.jpg";